import styled from "styled-components";

export const StyledJobList = styled.div`
  margin: 50px 0;
`;
